import PropTypes from 'prop-types';
import './styles/horizontalContentStyles.css';

const HorizontalContentContainer = ({ children, ...rest }) => (
  <div className="horizontal-content-container mr-10 w-1/2" {...rest}>
    {children}
  </div>
);

HorizontalContentContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HorizontalContentContainer;
